import axios from 'axios';
import i18n from '@/common/i18n/i18n.js';
import { setAxiosCsrfHeader } from '@/utils/requests.js';

const DEV_AUTH = process.env.NODE_ENV === 'development' ? true : false;

const AUTH = {
  username: process.env.VUE_APP_API_ADMIN_USERNAME,
  password: process.env.VUE_APP_API_ADMIN_PASSWORD
};

const path = require('path');
const DOMAIN = process.env.VUE_APP_DOMAIN;
const GEOSPATIAL_API_PATH = process.env.VUE_APP_GEOSPATIAL_API_PATH;

if (!DEV_AUTH) {
  axios.defaults.headers.common['X-CSRFToken'] = setAxiosCsrfHeader();
}

const geospatialAPI = {
  async getResourceGeographicLayerScenarios(id) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${id}/_scenarios/`
      ),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },
  async runResourceGeographicLayerScenario(id, scenarioId) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${id}/_scenarios/${scenarioId}/run/?asynchrone=false`
      ),
      DOMAIN
    );
    const response = await axios.post(url, null, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 202) {
      return response.data;
    }
    return false;
  },
  async getGeographicLayerStylesList(geographiclayerId) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${geographiclayerId}/style/`
      ),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },
  async createGeographicLayerStyle(id, payload) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${id}/style/`
      ),
      DOMAIN
    );
    const response = await axios.post(url, payload, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 201) {
      return response.data;
    }
    return false;
  },
  async getGeographicLayerStyle(geographiclayerId, styleId) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${geographiclayerId}/style/${styleId}/`
      ),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },
  async updateGeographicLayerStyle(geographiclayerId, styleId, payload) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${geographiclayerId}/style/${styleId}/`
      ),
      DOMAIN
    );
    const response = await axios.put(url, payload, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },
  async deleteGeographicLayerStyle(geographiclayerId, styleId) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${geographiclayerId}/style/${styleId}/`
      ),
      DOMAIN
    );
    const response = await axios.delete(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 204) {
      return response.data;
    }
    return false;
  },

  // Config
  async setGeographicLayerStyleConfig(geographiclayerId, styleId, config) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${geographiclayerId}/style/${styleId}/config/`
      ),
      DOMAIN
    );
    const response = await axios.put(url, config, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },
  async getGeographicLayerStyleConfig(url) {
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  // Scenario
  async getGeographicLayerStyleScenarios(geographiclayerId, styleId) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${geographiclayerId}/style/${styleId}/_scenarios/`
      ),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },
  async runGeographicLayerStyleScenario(geographiclayerId, styleId, scenarioId, data) {
    const url = new URL(
      path.join(
        `${i18n.locale}${GEOSPATIAL_API_PATH}`,
        `/geographiclayer/${geographiclayerId}/style/${styleId}/_scenarios/${scenarioId}/run/?asynchrone=true`
      ),
      DOMAIN
    );
    const response = await axios.post(url, data, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },
};

export default geospatialAPI;